// src/components/PoolInfoTag.js
import React from 'react';
import { Image } from 'react-bootstrap';

const PoolInfoTag = ({ poolData }) => {
    if (!poolData || poolData.value === 'custom') {
        return null;
    }

    return (
        <div className="pool-info-tag">
            <Image
                src={`/images/pools/${poolData.icon}`}
                alt={poolData.name}
                width="24"
                height="24"
            />
            <div className="pool-details">
                <span className="pool-name">{poolData.name}</span>
                <span className="pool-address">{poolData.host}:{poolData.port}</span>
            </div>
        </div>
    );
};

export default PoolInfoTag;